import type { SbCreativesSbAsinsModel } from "@m19-board/strategies/sb-create-strategy/steps/sb-creative-builder/sb-creative-builder.component";
import type { SbFormAssetsModel } from "@m19-board/strategies/sb-create-strategy/steps/sb-form-assets/sb-form-assets.component";
import type { SbFormFormatModel } from "@m19-board/strategies/sb-create-strategy/steps/sb-form-format/sb-form-format.component";
import type { SbFormSetupModel } from "@m19-board/strategies/sb-create-strategy/steps/sb-form-setup/sb-form-setup.component";
import { IFormNavigationStep, IFormStep } from "@m19-board/shared/form-navigation/form-navigation.service";

export interface SbWizardFormModel {
  setup: SbFormSetupModel;
  format: SbFormFormatModel;
  assets: SbFormAssetsModel;
  creativesSbAsins: SbCreativesSbAsinsModel;
}

export const SB_WIZARD_FORM_STEP: Record<IFormStep<SbWizardFormModel>, IFormNavigationStep<SbWizardFormModel>> = {
  setup: { stepId: "setup", label: "Setup", size: "sm" },
  format: { stepId: "format", label: "Format", size: "sm" },
  assets: { stepId: "assets", label: "Assets", size: "full" },
  creativesSbAsins: { stepId: "creativesSbAsins", label: "ASINs", size: "full" },
};

export const CREATE_STRATEGY_STEP_IDS: IFormNavigationStep<SbWizardFormModel>[] = [
  SB_WIZARD_FORM_STEP.setup,
  SB_WIZARD_FORM_STEP.format,
  SB_WIZARD_FORM_STEP.assets,
  SB_WIZARD_FORM_STEP.creativesSbAsins,
];

export const REACHED_AFTER_BRAND: IFormStep<SbWizardFormModel>[] = ["setup"];
export const REACHED_AFTER_CREATIVE_TYPE: IFormStep<SbWizardFormModel>[] = ["setup", "format"];
export const REACHED_AFTER_LANDING_PAGE: IFormStep<SbWizardFormModel>[] = ["setup", "format"];
export const REACHED_AFTER_STORE: IFormStep<SbWizardFormModel>[] = ["setup", "format", "assets"];

export const SB_STRATEGIES_URL = "/advertising/sponsored-brands";
export const TACOS_STRATEGIES_URL = "/advertising/tacos-strategies";
